export const translations = {
  en: {
    dir: "ltr",
    brand: "BeforeTheDeadline",
    brandShort: "BTD",
    tagline: "Resumes that get you to the interview — before the deadline.",
    heroTitle: "Land the interview.\nBefore the deadline.",
    heroSub: "Professionally crafted, ATS-friendly CV templates in Arabic and English. Pick your style, fill it yourself or let us write it for you.",
    shopNow: "Browse templates",
    explore: "Why us",
    search: "Search CV templates...",
    cart: "Cart",
    cartEmpty: "Your cart is empty",
    profile: "Profile",
    settings: "Settings",
    account: "Account",
    store: "My store",
    help: "Help center",
    darkMode: "Dark mode",
    language: "العربية",
    languageLabel: "Language",
    signIn: "Sign in",
    signOut: "Sign out",
    addToCart: "Add to cart",
    viewProduct: "View",
    subtotal: "Subtotal",
    vat: "VAT (15%)",
    total: "Total",
    checkout: "Checkout",
    continueShopping: "Continue browsing",
    qty: "Qty",
    sar: "SAR",
    features: "Why BeforeTheDeadline",
    f1Title: "ATS-friendly",
    f1Desc: "Optimized to pass applicant tracking systems",
    f2Title: "Bilingual",
    f2Desc: "Native Arabic & English layouts",
    f3Title: "Secure payment",
    f3Desc: "Apple Pay, Mada, Visa & Mastercard",
    customerName: "Full name",
    customerMobile: "Mobile number",
    customerCity: "City",
    customerEmail: "Email (optional)",
    checkoutDetails: "Checkout details",
    payWithStripe: "Pay securely",
    backToStore: "Back to store",
    paymentSuccess: "Payment successful",
    paymentProcessing: "Confirming payment...",
    paymentFailed: "Payment was not completed",
    viewInvoice: "View invoice",
    // product detail
    style: "Style",
    serviceType: "Service type",
    selectStyle: "Choose a style",
    selectService: "Choose a service",
    diy: "I'll do it myself",
    doneForYou: "We write & format for you",
    priceAddon: "+",
    selectStyleFirst: "Please choose a style first",
    selectServiceFirst: "Please choose a service type first",
    // admin
    dashboard: "Dashboard",
    customers: "Customers",
    orders: "Orders",
    products: "Templates",
    customerList: "Customer list",
    active: "Active",
    banned: "Banned",
    all: "All",
    name: "Name",
    mobile: "Mobile",
    city: "City",
    channel: "Channel",
    totalOrders: "Total orders",
    totalSpent: "Total spent",
    lastOrder: "Last order",
    status: "Status",
    actions: "Actions",
    ban: "Ban",
    unban: "Unban",
    invoice: "Invoice",
    print: "Print",
    orderNumber: "Order #",
    date: "Date",
    item: "Template",
    price: "Price",
    lineTotal: "Line total",
    billedTo: "Billed to",
    from: "From",
    paid: "Paid",
    pending: "Pending",
    storeAddress: "Riyadh, Kingdom of Saudi Arabia",
    storeVat: "VAT: 300000000000003",
    scanToVerify: "Scan to verify",
    backToStorefront: "Storefront",
    login: "Sign in",
    email: "Email",
    password: "Password",
    loginCta: "Sign in",
    loginHint: "Admin demo: admin@zayd.sa / admin1234",
    welcome: "Welcome back",
    statTotalCustomers: "Total customers",
    statActive: "Active",
    statBanned: "Banned",
    // OTP login
    tabEmail: "Email",
    tabPhone: "Phone",
    phoneLabel: "Phone number",
    sendCode: "Send verification code",
    enterCode: "Enter verification code",
    verifyCode: "Verify code",
    codeSent: "We sent a code to your phone. Use any 6 digits in this demo.",
    otpHint: "Mock SMS — any 6-digit code works (e.g., 123456)",
    breadcrumbHome: "Home",
    allProducts: "All templates",
    allCategories: "All categories",
    courses: "Courses",
    course: "Course",
    bookCourse: "Book a session",
    pickDay: "Pick a day",
    pickDuration: "Pick duration",
    pickTime: "Pick a time",
    duration30: "30 minutes",
    duration60: "1 hour",
    duration90: "1.5 hours",
    pricePerMin: "1 SAR / minute",
    bookAndPay: "Book & pay",
    customerInfoLabel: "Your information (we'll use this to write your CV)",
    customerInfoPlaceholder: "Full name, email, phone, education, work experience, skills, achievements...",
    customerInfoHint: "Required for 'We write & format' service.",
    availability: "Availability",
    weeklyAvailability: "Weekly availability",
    open: "Open",
    close: "Close",
    enabled: "Enabled",
    saveChanges: "Save changes",
    bookings: "Bookings",
    bookingsList: "Bookings list",
    bookingNumber: "Booking #",
    bookingDate: "Date",
    bookingTime: "Time",
    bookingDuration: "Duration",
    bookingCustomer: "Student",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    completed: "Completed",
    uploadFile: "Upload file",
    replaceFile: "Replace file",
    fileUploaded: "File uploaded",
    noFileYet: "No file yet",
    downloadFile: "Download your file",
    pendingFile: "Your file will be ready soon — we'll notify you.",
    confirmedAt: "Confirmed",
    sun: "Sun", mon: "Mon", tue: "Tue", wed: "Wed", thu: "Thu", fri: "Fri", sat: "Sat",
    sunday: "Sunday", monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday",
    thursday: "Thursday", friday: "Friday", saturday: "Saturday",
    notesLabel: "Notes (optional)",
    yourName: "Your name",
    yourPhone: "Your phone",
    yourEmail: "Your email (optional)",
    noBookings: "No bookings yet",
  },
  ar: {
    dir: "rtl",
    brand: "BeforeTheDeadline",
    brandShort: "BTD",
    tagline: "سير ذاتية توصلك للمقابلة — قبل انتهاء الموعد.",
    heroTitle: "احصل على المقابلة.\nقبل انتهاء الموعد.",
    heroSub: "قوالب سير ذاتية احترافية متوافقة مع أنظمة الفرز (ATS) بالعربية والإنجليزية. اختر نمطك، واملأه بنفسك أو دعنا نكتبه لك.",
    shopNow: "تصفح القوالب",
    explore: "لماذا نحن",
    search: "ابحث عن قوالب السير الذاتية...",
    cart: "السلة",
    cartEmpty: "سلتك فارغة",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    account: "حسابي",
    store: "متجري",
    help: "مركز المساعدة",
    darkMode: "الوضع الداكن",
    language: "English",
    languageLabel: "اللغة",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    addToCart: "أضف للسلة",
    viewProduct: "عرض",
    subtotal: "المجموع الفرعي",
    vat: "ضريبة القيمة المضافة (15%)",
    total: "الإجمالي",
    checkout: "إتمام الشراء",
    continueShopping: "متابعة التصفح",
    qty: "الكمية",
    sar: "ر.س",
    features: "لماذا BeforeTheDeadline",
    f1Title: "متوافق مع أنظمة الفرز",
    f1Desc: "مُحسّن لتجاوز أنظمة فرز السير الذاتية ATS",
    f2Title: "ثنائي اللغة",
    f2Desc: "تخطيط أصلي بالعربية والإنجليزية",
    f3Title: "دفع آمن",
    f3Desc: "آبل باي ومدى وفيزا وماستركارد",
    customerName: "الاسم الكامل",
    customerMobile: "رقم الجوال",
    customerCity: "المدينة",
    customerEmail: "البريد الإلكتروني (اختياري)",
    checkoutDetails: "بيانات الطلب",
    payWithStripe: "ادفع بأمان",
    backToStore: "العودة للمتجر",
    paymentSuccess: "تمّ الدفع بنجاح",
    paymentProcessing: "جاري تأكيد الدفع...",
    paymentFailed: "لم تكتمل عملية الدفع",
    viewInvoice: "عرض الفاتورة",
    style: "النمط",
    serviceType: "نوع الخدمة",
    selectStyle: "اختر النمط",
    selectService: "اختر الخدمة",
    diy: "بسويه بنفسي",
    doneForYou: "علينا النص وعلينا التنسيق",
    priceAddon: "+",
    selectStyleFirst: "الرجاء اختيار النمط أولاً",
    selectServiceFirst: "الرجاء اختيار نوع الخدمة أولاً",
    dashboard: "لوحة التحكم",
    customers: "العملاء",
    orders: "الطلبات",
    products: "القوالب",
    customerList: "قائمة العملاء",
    active: "نشط",
    banned: "محظور",
    all: "الكل",
    name: "الاسم",
    mobile: "الجوال",
    city: "المدينة",
    channel: "القناة",
    totalOrders: "إجمالي الطلبات",
    totalSpent: "إجمالي الإنفاق",
    lastOrder: "آخر طلب",
    status: "الحالة",
    actions: "إجراءات",
    ban: "حظر",
    unban: "إلغاء الحظر",
    invoice: "فاتورة",
    print: "طباعة",
    orderNumber: "رقم الطلب",
    date: "التاريخ",
    item: "القالب",
    price: "السعر",
    lineTotal: "الإجمالي",
    billedTo: "العميل",
    from: "من",
    paid: "مدفوع",
    pending: "قيد الانتظار",
    storeAddress: "الرياض، المملكة العربية السعودية",
    storeVat: "ر.ض: 300000000000003",
    scanToVerify: "امسح للتحقق",
    backToStorefront: "المتجر",
    login: "تسجيل الدخول",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    loginCta: "دخول",
    loginHint: "الحساب التجريبي: admin@zayd.sa / admin1234",
    welcome: "أهلاً بعودتك",
    statTotalCustomers: "إجمالي العملاء",
    statActive: "نشط",
    statBanned: "محظور",
    tabEmail: "بريد",
    tabPhone: "جوال",
    phoneLabel: "رقم الجوال",
    sendCode: "إرسال رمز التحقق بالرسالة النصية",
    enterCode: "أدخل رمز التحقق",
    verifyCode: "تحقق من الرمز",
    codeSent: "أرسلنا رمزاً إلى جوالك. استخدم أي 6 أرقام في هذا العرض التجريبي.",
    otpHint: "تجريبي — أي رمز من 6 أرقام يعمل (مثل 123456)",
    breadcrumbHome: "الرئيسية",
    allProducts: "جميع المنتجات",
    allCategories: "جميع التصنيفات",
    courses: "الدورات",
    course: "الدورة",
    bookCourse: "احجز جلسة",
    pickDay: "اختر اليوم",
    pickDuration: "اختر المدة",
    pickTime: "اختر الوقت",
    duration30: "٣٠ دقيقة",
    duration60: "ساعة",
    duration90: "ساعة ونصف",
    pricePerMin: "ر.س لكل دقيقة",
    bookAndPay: "احجز وادفع",
    customerInfoLabel: "معلوماتك (نستخدمها لكتابة سيرتك الذاتية)",
    customerInfoPlaceholder: "الاسم الكامل، البريد، الجوال، التعليم، الخبرات، المهارات، الإنجازات...",
    customerInfoHint: "مطلوب عند اختيار خدمة 'نكتب وننسّق'.",
    availability: "الأوقات المتاحة",
    weeklyAvailability: "الجدول الأسبوعي",
    open: "من",
    close: "إلى",
    enabled: "مفعّل",
    saveChanges: "حفظ التعديلات",
    bookings: "الحجوزات",
    bookingsList: "قائمة الحجوزات",
    bookingNumber: "رقم الحجز",
    bookingDate: "التاريخ",
    bookingTime: "الوقت",
    bookingDuration: "المدة",
    bookingCustomer: "الطالب",
    confirmed: "مؤكد",
    cancelled: "ملغى",
    completed: "مكتمل",
    uploadFile: "رفع ملف",
    replaceFile: "استبدال الملف",
    fileUploaded: "تم الرفع",
    noFileYet: "لا يوجد ملف بعد",
    downloadFile: "حمّل ملفك",
    pendingFile: "ملفك قيد التحضير — سنشعرك عند جاهزيته.",
    confirmedAt: "مؤكد",
    sun: "أحد", mon: "اثنين", tue: "ثلاثاء", wed: "أربعاء", thu: "خميس", fri: "جمعة", sat: "سبت",
    sunday: "الأحد", monday: "الاثنين", tuesday: "الثلاثاء", wednesday: "الأربعاء",
    thursday: "الخميس", friday: "الجمعة", saturday: "السبت",
    notesLabel: "ملاحظات (اختياري)",
    yourName: "الاسم",
    yourPhone: "رقم الجوال",
    yourEmail: "البريد الإلكتروني (اختياري)",
    noBookings: "لا توجد حجوزات بعد",
  },
};

export const formatSAR = (amount, lang = "en") => {
  const n = Number(amount || 0).toLocaleString(lang === "ar" ? "ar-SA" : "en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return lang === "ar" ? `${n} ر.س` : `${n} SAR`;
};
